<template>

    <wizard-step-card
            header="Wie können wir Ihnen helfen?"
            :reason="_getCurrentReason"
            v-on:stepdone="stepDone"
            v-on:abbort="$emit('abbort')"
    >

        <div class="row mb-3">
            <div class="col-lg-8 col-xs-12 offset-lg-2">
                <info-header icon="far fa-question-circle">
                    <template slot="titel">
                        Wie können wir Ihnen helfen?
                    </template>

                    <template slot="leed">

                        <div v-if="isValidOrder()">
                            Bitte wählen Sie die passende Option und klicken Sie auf "Nächster Schritt"
                        </div>

                        <div v-if="!isValidOrder()">
                            Bitte nutzen Sie das Formular im nächsten Schritt und beschreiben Sie unserem Kundenservice
                            Ihr Anliegen und wie wir Ihnen weiterhelfen können!
                        </div>

                    </template>
                </info-header>
            </div>
        </div>

        <div class="row ">

            <!-- Show all reasons -->
            <div v-if="isValidOrder()" class="col-6" v-for="(reason, value) in getReasons" :key="reason">

                <select-item :value="value" v-on:select="setoption" :active="value===option">
                    {{ reason }}
                </select-item>

            </div>

            <!-- Show onliy reason other -->
            <div v-if="!isValidOrder()" class="col-lg-8 col-xs-12 offset-lg-2">

                <select-item ref="singleselect" value="other" v-on:select="setoption" :active="true">
                    {{ getReasons.other }}
                </select-item>

            </div>


        </div>

    </wizard-step-card>

</template>

<script>
    import InfoHeader from '../../elements/InfoHeader'
    import WizardStepCard from '../../elements/WizardStepCard'
    import SelectItem from '../../elements/SelectItem'

    export default {
        name: "firststep",

        data: () => ({
            triggerreset: false,
        }),

        components: {
            WizardStepCard,
            SelectItem,
            InfoHeader
        },

        computed: {
            option: {

                get () {
                  return this.$store.getters.getReason
                },

                set (newValue) {

                  this.triggerreset = !this.triggerreset

                  let reasonString = this.$store.getters.getReasons[ newValue ]

                  this.$store.commit('setReason', newValue)
                  this.$store.commit('setReasonString', reasonString)
                }
            },

            getReasons () {
                return this.$store.getters.getReasons
            },

            _getCurrentReason () {

                let reasonCode = this.$store.getters.getReason

                return this.$store.getters.getReasons[ reasonCode ] || 'Sie haben noch keine Auswahl getroffen!'
            },

        },
        
        methods: {
            setoption (value) {
                this.option = value
            },

            stepDone () {

                if(!this.option){
                    this.$swal({
                        text: 'Sie haben keine Option gewählt',
                        icon: 'error'
                    })

                    return
                }

                this.$emit('stepdone', '1')
            },

            isValidOrder () {

                // Check if order older than 6 month

                const orderId = this.$store.getters.getCurrentOrderId

                const createdAt =  this.$store.getters.getOrders.find(x => x.id === orderId).createdAt

                const d = new Date();
                d.setMonth(d.getMonth() - 6);
                d.setHours(0, 0, 0);
                d.setMilliseconds(0);

                const result = !((new Date(createdAt) / 1000) < (d/1000))

                if(!result && this.option !== 'other') {
                    this.setoption('other')
                }

                return result
            }
        }
    }
</script>

<style scoped>
</style>